// Aviso de "o número da barra mudou".
//
// A estrela e o relógio ficam na linha do atendimento; os contadores deles, na
// barra de ferramentas, que é outro pedaço da tela. Sem este aviso o número só
// acertaria no F5 — o mesmo motivo do evento das preferências.
export const EVENTO_CONTADORES = "contadoresDaLista";

// `tipo`: "favoritos" ou "pausa".
export const avisarContadores = (tipo) =>
  window.dispatchEvent(new CustomEvent(EVENTO_CONTADORES, { detail: { tipo } }));
